/**
 * frontend javascript initiation file
 *
 * @package Wordpress/sww
 * @since 1.0.0
 * @version 1.0.0
 */

if( !window.swwapp ) {

	window.swwapp = {};

}

var swwapp = window.swwapp;

swwapp.jsdebug = false;

if( swwapp.jsdebug == true ) { console.log( 'init.js loaded' ); }
